import { DataTableAction, DataTableLabel, Flex, Text, Tooltip } from '@optiaxiom/react';

import { UserInstruction } from '@frontend/features/userInstructions/types';

type NameCellProps = {
  instruction: UserInstruction;
  onClick: () => void;
};

export const NameCell = ({ instruction, onClick }: NameCellProps) => {
  return (
    <DataTableLabel asChild>
      <DataTableAction flex="initial" overflow="hidden" primary>
        <Flex
          flexDirection="column"
          alignItems="start"
          gap="4"
          onClick={onClick}
          cursor="pointer"
          w="full"
        >
          <Text fontSize="md" fontWeight="500" truncate>
            {instruction.title}
          </Text>
          <Tooltip content={instruction.instruction_sementics}>
            <Text fontSize="sm" color="fg.tertiary" lineClamp="1">
              {instruction.instruction}
            </Text>
          </Tooltip>
        </Flex>
      </DataTableAction>
    </DataTableLabel>
  );
};
